module.exports = __webpack_public_path__ + "static/a-frame-sign-1b10aaea08bb2b4f8bf4e57ead1eb1e0.jpg";